import { render } from "./event-descriptor.vue?vue&type=template&id=8392aeb0&scoped=true"
import script from "./event-descriptor.vue?vue&type=script&lang=js"
export * from "./event-descriptor.vue?vue&type=script&lang=js"

import "./event-descriptor.vue?vue&type=style&index=0&id=8392aeb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8392aeb0"]])

export default __exports__